module.exports = __webpack_public_path__ + "img/google_calendar.b62b5b6b.png";